import React, { useEffect } from 'react'
 import Cookies from 'js-cookie'
 
const LogOut =()=> {


  const clearCookies=()=>{
    Cookies.remove('gaatkaustnm')
     Cookies.remove('gaatkauscd')	
    Cookies.remove('gaatkagpcd')
    Cookies.remove('gaatkamtk')
    Cookies.remove('gaatkarfsh')




    Cookies.remove('tkrspw')
    Cookies.remove('portal')
    Cookies.remove('kayus_ed')
    Cookies.remove('kayus_dt')
    Cookies.remove('clkysd')
    Cookies.remove('sckayd')


    localStorage.setItem('_gaatexpt', Date.now())
    localStorage.setItem('_gaatbexpt', Date.now())
    localStorage.setItem('_gaatmnulk', Date.now())
    localStorage.setItem('kayus_link', [])


  }

 useEffect(()=>{  
  clearCookies()
  window.open("/", '_self')
},[]); 

  return (
    <div>...please wait</div>
  )
}

export default LogOut